export const PROJECT_REPOSITORY_URL = 'https://github.com/picspin/sci-necromancer';
